var _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 131,
    viewBox: "0 0 132 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 132,
    height: 131
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.2915,
    cy: 65.4514,
    rx: 65.4514,
    ry: 65.4514,
    fill: "#00AF91"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.2915,
    cy: 65.4514,
    rx: 65.4514,
    ry: 65.4514,
    fill: "#00AF91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.019 103.129C110.689 93.8142 103.933 93.355 94.093 96.1757C82.2199 99.5868 76.1849 112.378 80.6455 123.53C84.3846 132.845 90.2228 148.523 94.9458 161.642L128.991 152.721C125.645 134.813 120.07 113.887 115.019 103.129Z",
    fill: "#60CAF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8529 165.381C23.9695 150.49 -2.40073 127.4 -0.170414 112.116C1.07594 103.326 27.5773 75.7093 70.5437 74.3973C84.2535 74.0037 106.491 87.1232 111.936 97.2252C130.762 132.32 104.261 173.122 112.001 218.187C114.494 232.684 118.43 241.868 104.261 251.314C94.2243 258.005 85.6967 269.943 73.0364 268.894C49.2901 266.992 20.624 271.977 12.8835 251.576C4.02782 228.42 11.5715 186.7 18.8529 165.381Z",
    fill: "#60CAF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2565 34.9078C48.8964 29.4632 56.5713 21.6571 62.5407 20.2795C66.3453 19.4268 65.2302 17.9836 69.1004 18.574C72.9707 19.1644 77.0377 19.9516 78.8088 23.1658C80.252 25.7897 82.8759 28.8728 82.8103 31.7591C82.7447 32.6119 82.7447 33.4646 82.3511 34.2518C81.8919 35.039 81.1048 35.695 80.3176 36.2197C76.5129 38.8436 71.8555 40.8116 68.5756 44.0914C66.1485 46.5841 64.2462 62.3931 59.9824 62.1963C51.9795 61.8683 45.5509 40.6148 47.2565 34.9078Z",
    fill: "#1D113E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3643 64.2293C74.0203 63.7701 74.8075 63.7046 75.5946 63.5078C79.3993 62.4582 81.6952 58.5223 82.7448 54.7177C84.9751 46.9772 83.7287 38.2527 79.5305 31.4306C77.0378 27.4291 73.0363 23.7557 68.3133 23.6901C62.6719 23.6245 58.0801 28.6755 56.7026 34.0545C55.325 39.4991 56.4402 45.2061 57.4897 50.7162C58.4737 55.7673 57.2273 79.9727 61.688 83.2526C75.4634 93.3546 70.0188 66.4596 73.3643 64.2293Z",
    fill: "#FE9784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3762 45.7966C59.3922 44.2879 57.6211 43.1727 55.7843 43.3039C53.9476 43.3695 52.1765 44.8127 51.9797 46.5838C51.7829 48.2238 52.7013 49.7325 53.554 51.11C55.0628 53.4716 56.8339 56.0299 59.5234 56.9482C59.7858 57.0138 60.0482 57.0794 60.3106 57.0138C60.6385 56.9482 60.8353 56.6858 60.9665 56.4234C62.7377 53.6027 61.4913 49.8637 60.1794 46.7806L60.3762 45.7966Z",
    fill: "#FE9784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1486 105.425C10.5874 102.932 4.42128 101.62 -0.498533 111.394C-5.22155 120.709 -10.9941 138.027 -15.3892 154.558L23.3789 168.136C29.2827 156.919 35.6457 144.915 39.3191 136.715C44.5013 125.039 33.9401 108.443 21.1486 105.425Z",
    fill: "#60CAF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2142 86.7953C71.1775 86.7953 75.201 84.4164 75.201 81.4819C75.201 78.5473 71.1775 76.1685 66.2142 76.1685C61.2509 76.1685 57.2273 78.5473 57.2273 81.4819C57.2273 84.4164 61.2509 86.7953 66.2142 86.7953Z",
    fill: "#FE9784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9839 25.039L68.9493 21.178C67.0429 21.6728 65.0909 20.5395 64.5802 18.6335L62.721 11.6947L60.6349 9.74728L57.4772 9.60143C57.0985 9.58394 56.7239 9.68432 56.4047 9.88881L27.4267 28.4527C25.8101 29.4882 26.6735 31.997 28.5849 31.8186L62.0191 28.6967L69.9839 25.039Z",
    fill: "#407093"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9653 21.2376L64.2054 21.9022C61.6401 22.2605 59.1287 22.9334 56.7283 23.9059L39.7761 30.7737L41.8696 38.5871C42.0965 39.4337 42.9668 39.9362 43.8134 39.7093L71.8983 32.184L68.9653 21.2376Z",
    fill: "#4A80AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.855 11.1894L60.635 9.74756L63.0915 18.9152C63.5961 20.7986 65.525 21.9186 67.4087 21.4297L68.5521 25.697L92.5347 14.6837C94.2794 13.8821 93.7727 11.278 91.855 11.1894Z",
    fill: "#407093"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4156 21.4541L70.3984 32.586L83.2985 29.1295C84.1451 28.9026 84.6476 28.0323 84.4207 27.1857L82.3271 19.3721L67.4156 21.4541Z",
    fill: "#4A80AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4883 48.431L36.7032 47.1734L33.6437 47.8589L32.5659 49.758L33.1604 61.2532C33.2165 62.3382 34.2354 63.1118 35.2956 62.8742L41.616 61.4581C42.6763 61.2205 43.2676 60.0861 42.8554 59.0809L38.4883 48.431Z",
    fill: "#E4F6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3204 46.09L33.1833 32.0889C33.0105 31.3178 32.2453 30.8327 31.4742 31.0055C30.7031 31.1783 30.2181 31.9435 30.3908 32.7146L33.528 46.7157L36.3204 46.09Z",
    fill: "#407093"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4883 48.4312L32.5661 49.7582L31.695 45.8706C31.5099 45.0446 32.0295 44.225 32.8555 44.0399L35.7864 43.3832C36.6124 43.1981 37.432 43.7176 37.6171 44.5437L38.4882 48.4312L38.4883 48.4312Z",
    fill: "#FFE07D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent);
export default __webpack_public_path__ + "static/media/student.9521d5f194456ccccf5c87d403d3b541.svg";
export { ForwardRef as ReactComponent };